var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendQuery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 596.68227 599.91163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        isolation: isolate;\r\n        fill: #7c7c7c;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #c6c6c6;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dark",
    className: "cls-1",
    d: "M316.97631,140.99632,602.31,283.663c128,64.00035,128,168.667,0,232.667L316.97631,658.99662c-192,96-270.33331,17.33335-174.33331-174.33331l29-57.66665a60.72729,60.72729,0,0,0,0-53.66669l-29-58.0003C46.643,123.663,125.30966,44.99633,316.97631,140.99632Z",
    transform: "translate(-101.6277 -100.04067)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "light",
    className: "cls-2",
    d: "M494.65,425H314.64833a25,25,0,1,1,0-50H494.65a25,25,0,0,1,0,50Z",
    transform: "translate(-101.6277 -100.04067)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendQuery);
export default __webpack_public_path__ + "static/media/send-query.98c9bb5e.svg";
export { ForwardRef as ReactComponent };